function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, useFormContext } from 'react-hook-form';
import { cityNameValidation, postalCodeValidation, streetNameValidation } from 'validators';
import { Grid, GridItem, MenuItem, Select, TextField } from 'seagull';
import { AddressAutocomplete } from "../AddressAutocomplete";
import { states as statesList } from "../../constants";
import { connectControllerToAutocomplete, connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PostalAddressForm(props) {
  const {
    testid = 'postal-address-form'
  } = props;
  const {
    control,
    setValue
  } = useFormContext();
  const addressOneValidator = streetNameValidation(undefined, {
    required: true
  });
  const addressTwoValidator = streetNameValidation();
  const cityValidator = cityNameValidation(undefined, {
    required: true
  });
  const stateValidator = {
    required: true
  };
  const postalCodeValidator = postalCodeValidation(undefined, {
    required: true
  });
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small",
    "data-testid": "".concat(testid),
    children: [/*#__PURE__*/_jsx(GridItem, {
      span: 12,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "postalAddress.address1",
        rules: addressOneValidator,
        render: renderProps => {
          return /*#__PURE__*/_jsx(AddressAutocomplete, _objectSpread(_objectSpread({
            testid: "".concat(testid, "-address-1")
          }, connectControllerToAutocomplete(renderProps, {
            label: 'Address 1',
            placeholder: 'Enter an address'
          })), {}, {
            onSelectPlace: place => {
              if (!place || !place.formatted) return;
              const {
                address1,
                address2,
                city,
                state,
                postalCode
              } = place.formatted;
              const options = {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true
              };
              setValue('postalAddress.address1', address1, options);
              setValue('postalAddress.address2', address2, options);
              setValue('postalAddress.city', city, options);
              setValue('postalAddress.state', state, options);
              setValue('postalAddress.postalCode', postalCode, options);
            }
          }));
        }
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      span: 12,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "postalAddress.address2",
        rules: addressTwoValidator,
        render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
          "data-testid": "".concat(testid, "-address-2"),
          label: "Address 2 (optional)"
        }))
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      span: 5,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "postalAddress.city",
        rules: cityValidator,
        render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
          "data-testid": "".concat(testid, "-city"),
          label: "City"
        }))
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      span: 3,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "postalAddress.state",
        rules: stateValidator,
        render: renderProps => /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
          label: "State",
          "data-testid": "".concat(testid, "-state"),
          children: statesList.map(state => /*#__PURE__*/_jsx(MenuItem, {
            value: state,
            "data-testid": "".concat(testid, "-state-option-").concat(state),
            children: state
          }, state))
        }))
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      span: 4,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "postalAddress.postalCode",
        rules: postalCodeValidator,
        render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
          "data-testid": "".concat(testid, "-postal-code"),
          label: "ZIP Code"
        }))
      })
    })]
  });
}